import createHostComponent from '../../createHostComponent';
import defaults from './props/default';
var Text = createHostComponent('text', null, defaults);
export default Text;
